<h1 > {{ GetDescription() }}  {{ GetValueAsString(mValue) }}   <app-unit [unit]="GetUnit()"></app-unit>   </h1>
<kendo-arcgauge class="simplegauge"   [value]="GetMeasurement()" [scale]="{ min: GetLow(), max: GetHigh() }">
  <ng-template   kendoArcGaugeCenterTemplate   let-value="value" >
    <span >{{ GetValueAsString(mValue) }} <app-unit [unit]="GetUnit()"></app-unit> </span>
  </ng-template>
</kendo-arcgauge>
Range : {{ GetLow() }} / {{ GetHigh() }}
